import { useState } from 'react';

interface ConsiglioEntry {
  id: string;
  text: string;
  nickname: string;
  team: string;
  timestamp: number;
}

interface ConsiglioMasterViewProps {
  entries: ConsiglioEntry[];
  sessionId: string;
}

const TEAM_BADGE_COLORS: Record<string, string> = {
  BLUE: 'bg-blue-600',
  RED: 'bg-red-600',
  GREEN: 'bg-green-600',
  YELLOW: 'bg-yellow-600',
  blue: 'bg-blue-600',
  red: 'bg-red-600',
  green: 'bg-green-600',
  yellow: 'bg-yellow-600',
};

export default function ConsiglioMasterView({ entries, sessionId }: ConsiglioMasterViewProps) {
  const [selectedEntryId, setSelectedEntryId] = useState<string | null>(null);

  const handleSelectEntry = async (entryId: string) => {
    try {
      const response = await fetch('/api/consiglio/select-entry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId, entryId }),
      });

      if (response.ok) {
        setSelectedEntryId(entryId);
      }
    } catch (error) {
      console.error('Error selecting entry:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-teal-900 p-8">
      <h1 className="text-5xl font-bold text-white text-center mb-2">
        Consigli dal pubblico
      </h1>
      <p className="text-center text-gray-400 mb-8">Clicca un consiglio per proiettarlo sul display</p>

      {entries.length === 0 && (
        <div className="text-center py-16">
          <p className="text-3xl text-gray-400">In attesa di consigli...</p>
        </div>
      )}

      <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
        {entries.map((entry) => (
          <div
            key={entry.id}
            onClick={() => handleSelectEntry(entry.id)}
            className={`break-inside-avoid mb-6 rounded-xl p-6 border animate-[fadeIn_0.5s_ease-in] cursor-pointer transition-all ${
              selectedEntryId === entry.id
                ? 'bg-teal-900/80 border-teal-500 ring-2 ring-teal-500/50'
                : 'bg-gray-800/80 border-gray-700 hover:bg-gray-700/80 hover:border-teal-500'
            }`}
          >
            <div className="flex items-center gap-2 mb-3">
              <span className="text-white font-bold text-lg">{entry.nickname}</span>
              <span className={`text-xs px-2 py-1 rounded-full text-white ${
                TEAM_BADGE_COLORS[entry.team] || 'bg-gray-600'
              }`}>
                {entry.team}
              </span>
            </div>
            <p className="text-gray-200 text-xl leading-relaxed">{entry.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
